import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "options", "hidden"]
  static values = { open: Boolean, selected: String, placeholder: String }

  connect() {
    this.openValue = false
    this.placeholderValue = this.placeholderValue || "Selecione"
    document.addEventListener("click", this.closeOnOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside)
  }

  closeOnOutside = (e) => {
    if (!this.element.contains(e.target)) {
      this.openValue = false
      this.render()
    }
  }

  toggle() {
    if (this.buttonTarget.disabled) return

    const hasOptions = this.optionsTarget.children.length > 0
    if (!hasOptions) return
    this.openValue = !this.openValue
    this.render()
  }

  select(e) {
    this.choose(e.currentTarget)
  }

  // Programmatically pick the option with `value` — used to pre-fill a
  // default selection (home card defaults) without a user click.
  selectByValue(value) {
    const option = this.optionsTarget.querySelector(`.ford-card-select__option[data-value="${CSS.escape(value)}"]`)
    if (option) this.choose(option)
  }

  choose(option) {
    const value = option.dataset.value
    const text = option.dataset.label || option.textContent.trim()

    this.selectedValue = value
    this.hiddenTarget.value = value
    this.labelTarget.textContent = text
    this.labelTarget.classList.remove("text-gray-400")
    this.labelTarget.classList.add("text-ford-blue")
    this.openValue = false
    this.render()

    // Dispatch change event for cascading selects
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  reset() {
    this.selectedValue = ""
    this.hiddenTarget.value = ""
    this.labelTarget.textContent = this.placeholderValue
    this.labelTarget.classList.add("text-gray-400")
    this.labelTarget.classList.remove("text-ford-blue")
    this.openValue = false
    this.render()
  }

  render() {
    const btn = this.buttonTarget
    const opts = this.optionsTarget

    if (this.openValue) {
      opts.style.display = "block"
      btn.style.borderBottomLeftRadius = "0"
      btn.style.borderBottomRightRadius = "0"
      btn.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1), 0 8px 24px rgba(0,0,0,0.1)"
      this.element.classList.add("open")
    } else {
      opts.style.display = "none"
      btn.style.borderBottomLeftRadius = ""
      btn.style.borderBottomRightRadius = ""
      btn.style.boxShadow = ""
      this.element.classList.remove("open")
    }
  }
}
